import Account from "./components/Account";
import CTA from "./components/CTA";
import CTA_2 from "./components/CTA_2";
import Contact from "./components/Contact";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";
import Hiro from "./components/Hiro";
import Services from "./components/Services";
import Steps from "./components/Steps";
import Home from "./components/Home";
import ScrollToTopButton from "./components/Scrolling";
import NotFound from "./components/NotFound";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Handymans from "./components/Handymans";
import B2b from "./components/B2b";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<B2b />} />
        <Route path="/b2b" ele  ment={<Home />} />
        <Route path="/handyman" element={<Handymans />} />
        <Route path="/services" element={<Services />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
      {/* <Contact /> */}
      <Footer />
      <ScrollToTopButton />
    </Router>
  );
}

export default App;
